var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ready) ? _c('div', {
    staticStyle: {
      "background": "#ffffff",
      "overflow-y": "auto"
    },
    attrs: {
      "id": "grid-layout"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "table",
      "height": "100%",
      "margin": "auto",
      "width": "100%"
    },
    attrs: {
      "id": "row-container"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "table-cell",
      "vertical-align": "middle",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0px"
    }
  }, [_vm._l((_vm.iterable), function(iter, index) {
    return _c('div', {
      class: _vm.classes[index]
    }, [_c('div', {
      staticClass: "thumbnail",
      staticStyle: {
        "margin": "10px 0px"
      },
      attrs: {
        "id": 'thumb-' + index
      }
    }, [_c('a', {
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          iter.typ == 'Articoli di stampa' ? _vm.loadDoc(iter) : _vm.activeData.father.pvi ? '' : _vm.$root.navigateTo(iter.sid, iter.fid)
        }
      }
    }, [_c('div', {
      staticClass: "embed-responsive embed-responsive-4by3 bg-cover",
      style: ({
        'width': '100%',
        'background-image': 'url(' + _vm.anteprima(iter) + ')'
      }),
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.activeData.father.pvi ? _vm.openImage(iter, index, $event) : ''
        }
      }
    }), _vm._v(" "), (_vm.activeData.father.pvi) ? _c('div', {
      staticClass: "caption"
    }, [(_vm.$Behaviors.showInfoOnGridBox) ? _c('div', [_c('div', {
      staticClass: "cod-label",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_vm._v(_vm._s(iter.spi ? iter.spi : iter.sid) + " - " + _vm._s(_vm.$Jed.firstUpperTranslate('qty')) + ": " + _vm._s(iter.qty))]), _vm._v(" "), _c('div', {
      staticClass: "cod-label",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_vm._v(_vm._s(iter.des))]), _vm._v(" "), _c('div', {
      staticClass: "cod-label",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_vm._v(_vm._s(iter.spe ? iter.spe : ' - '))]), _vm._v(" "), (!_vm.$Components['GridBox.purchase'].hidden) ? _c('div', {
      staticClass: "cod-label row",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#3c8dbc"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPurchasePopup(iter, index, $event)
        }
      }
    }, [_c('i', {
      class: _vm.$root.icons.cart,
      staticStyle: {
        "font-size": "1.2em"
      }
    }), _vm._v(" Scegli\n                    ")])]) : _vm._e()]) : _c('div', [_c('div', {
      staticClass: "cod-label",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_vm._v(_vm._s(iter.des))]), _vm._v(" "), (!_vm.$Components['GridBox.purchase'].hidden) ? _c('div', {
      staticClass: "cod-label row",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "#3c8dbc"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openPurchasePopup(iter, index, $event)
        }
      }
    }, [_c('i', {
      class: _vm.$root.icons.cart,
      staticStyle: {
        "font-size": "1.2em"
      }
    }), _vm._v(" Scegli\n                    ")])]) : _vm._e()])]) : _c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "cod-label",
      staticStyle: {
        "font-size": "smaller"
      }
    }, [(_vm.showId) ? _c('span', [_vm._v(_vm._s(iter.spi ? iter.spi : iter.sid + " - "))]) : _vm._e(), _vm._v(_vm._s(iter.des))])])])])])
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "sk-cube-grid",
    staticStyle: {
      "position": "absolute",
      "top": "38%",
      "left": "48%"
    }
  }, [_c('div', {
    staticClass: "sk-cube sk-cube1 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube2 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube3 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube4 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube5 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube6 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube7 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube8 loading-nav-waiter"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-cube sk-cube9 loading-nav-waiter"
  })]) : _vm._e(), _vm._v(" "), _c('single-modal', {
    attrs: {
      "title": _vm.$Jed.firstUpperTranslate(this.merchModalConfigs.title),
      "options": _vm.merchModalConfigs
    },
    on: {
      "API": function($event) {
        _vm.MerchModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "modal-input"
  }, [(_vm.merchModalConfigs.type == 'image') ? _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": this.merchModalConfigs.content
    }
  }) : _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "overflow-x": "hidden",
      "max-height": "-webkit-fill-available"
    },
    attrs: {
      "id": "dynTableWCont"
    }
  }, [_c('dyn-table-wrapper', {
    attrs: {
      "arrayToTable": this.merchModalConfigs.array,
      "name": "merchGrid"
    }
  })], 1)])]), _vm._v(" "), _c('purchasePopup', {
    attrs: {
      "id": "merchPurchasePopup",
      "chooseQty": _vm.chooseQty,
      "purchaseSid": _vm.purchaseSid,
      "purchaseDes": _vm.purchaseDes,
      "purchasePrice": _vm.purchasePrice,
      "popupHeight": _vm.popupHeight,
      "product": _vm.product,
      "arrayToTable": _vm.prodInCart,
      "tableConfigs": {
        title: 'merchGrid'
      }
    }
  })], 2)])])]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-456f88ba","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub-views/Grid.vue
// module id = 1647
// module chunks = 1